import axios from "axios";
import { atom } from "jotai";

import { SocialReferralInfo } from "./social-referral.types";

export const socialReferralPageAtom = atom<SocialReferralInfo>(async () => {
  try {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
    const sweepFormUrl =
      document
        .querySelector("#FormSweepstake")
        ?.getAttribute("data-form-path-url") ?? "";

    if (submission) {
      const { data }: { data: SocialReferralInfo } = await axios.post(
        `${window.FKL.yentaServicesApiUrl}/social-referral${sweepFormUrl}`,
        {
          formio_submission_id: submission?._id,
        }
      );
      return data as SocialReferralInfo;
    }
    return {
      social_referral_link: "",
      social_referral_extra_entries: 0,
      social_referral_max_extra_entries: 0,
    };
  } catch (error) {
    throw new Error(error.response?.data?.message ?? error.message);
  }
});
